import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Users, UserPlus, Search } from 'lucide-react';

export default function Friends() {
  return (
    <div className="space-y-8 pb-20 md:pb-8">
      {/* Header */}
      <div className="space-y-4">
        <h1 className="text-4xl md:text-5xl font-heading font-bold tracking-tight">
          Friends
        </h1>
        <p className="text-lg text-gray-400">
          Connect with people and attend events together
        </p>
      </div>

      {/* Coming Soon */}
      <Card className="glass border-white/10 p-12 text-center">
        <Users className="h-16 w-16 text-primary mx-auto mb-4" />
        <h3 className="text-2xl font-heading font-bold mb-2">Friends Coming Soon</h3>
        <p className="text-gray-400 mb-6">
          Build your network and discover events with friends
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Button variant="outline" className="glass-hover">
            <Search className="h-4 w-4 mr-2" />
            Find Friends
          </Button>
          <Button variant="outline" className="glass-hover">
            <UserPlus className="h-4 w-4 mr-2" />
            Send Request
          </Button>
        </div>
      </Card>

      {/* Features Preview */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card className="glass border-white/10">
          <CardContent className="p-6 text-center space-y-3">
            <Users className="h-12 w-12 text-primary mx-auto" />
            <h3 className="font-heading font-bold">Friend List</h3>
            <p className="text-sm text-gray-400">
              Keep track of all your event buddies in one place
            </p>
          </CardContent>
        </Card>

        <Card className="glass border-white/10">
          <CardContent className="p-6 text-center space-y-3">
            <UserPlus className="h-12 w-12 text-secondary mx-auto" />
            <h3 className="font-heading font-bold">Friend Requests</h3>
            <p className="text-sm text-gray-400">
              Accept or send friend requests to grow your network
            </p>
          </CardContent>
        </Card>

        <Card className="glass border-white/10">
          <CardContent className="p-6 text-center space-y-3">
            <Search className="h-12 w-12 text-accent-cyan mx-auto" />
            <h3 className="font-heading font-bold">Discover Together</h3>
            <p className="text-sm text-gray-400">
              See what events your friends are attending
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
